import type { Nil } from "@mcwd/typescript-type-guards";
import type { LanguageCountryLocale } from "../../../types-and-definitions/locale-defs/Locales.js";
import { BrowserPreferredLanguage } from "../BrowserPreferredLanguage.js";

export function getSiteLangFromBrowserLanguage (): LanguageCountryLocale | Nil
{
  return BrowserPreferredLanguage.value;
}
